import { createContext as createReactRouterContext } from 'react-router';

// This file is separate because we need to add "server-only" separately
// oxlint-disable-next-line typescript/no-explicit-any
export const reactRouterServerContext = createReactRouterContext<any>();
